<template>
	<div class="countier">
		<div class="search">
			<van-search v-model="searchText" shape="round" show-action background="#fff" placeholder="请输入您要搜索的商品名称"
				@search="onSearch(searchText)">
				<div slot="action" @click="onSearch(searchText)">搜索</div>
			</van-search>
			<div class="filter flex_a" v-if="!isShow && gosList.length > 0">
				<div :class="sortKey == '' ? 'color' : ''" @click="() => sortFg('')">
					综合
				</div>
				<div :class="sortKey == 'jinbi' ? 'color flex' : 'flex'" @click="() => sortFg('jinbi')">
					<div>积分</div>
					<div>
						<Iconfont name="iconarrLeft-fill" class="icon" size="0.6rem" :color="sortKey == 'jinbi' && orderType == 'asc' ? markColor : '#999999'
				" />
						<Iconfont name="iconsanjiao_xia" class="icon" size="0.6rem" :color="sortKey == 'jinbi' && orderType == 'desc'
				? markColor
				: '#999999'
				" />
					</div>
				</div>
				<div :class="sortKey == 'sales' ? 'color flex' : ' flex'" @click="() => sortFg('sales')">
					<div>兑换量</div>
					<div>
						<Iconfont name="iconarrLeft-fill" class="icon" size="0.6rem" :color="sortKey == 'sales' && orderType == 'asc' ? markColor : '#999999'
				" />
						<Iconfont name="iconsanjiao_xia" class="icon" size="0.6rem" :color="sortKey == 'sales' && orderType == 'desc'
				? markColor
				: '#999999'
				" />
					</div>
				</div>
			</div>
			<!-- <div>scrollTop：{{scrollTop}} scrollHeight：{{scrollHeight}}</div> -->
		</div>
		<div :class="[!isShow && gosList.length > 0 ? 'zhan' : 'two_zhan']"></div>
		<div v-if="isShow">
			<div class="hestort_search" v-if="!isNewMode || (isNewMode && searchHistories.length > 0)">
				<div class="history_left">历史搜索</div>
				<qdd-icon class="iconshanchu1" color="#ccc" size=".6rem" @click="dele"></qdd-icon>
			</div>
			<!-- 搜索历史 -->
			<div class="hui_m" :style="{ 'background-color': isNewMode ? '#fff' : '#f6f5f8' }" v-if="noHistory">
				<div class="search_history" v-for="(item, index) in searchHistories" :key="index" @click="onSearch(item)">
					<i class="history_txt">{{ item }}</i>
				</div>
			</div>
			<div v-else>
				<div class="noHistory" v-if="!isNewMode">暂时没有历史记录</div>
			</div>


		</div>
		<div class="hui_m" v-else-if="!isShow && gosList.length > 0">
			<div v-if="!isNewMode" class="warp_box_a">
				<div class="box" v-for="gods in gosList" :key="gods.stock_id" @click="jump(gods.stock_id)">
					<div class="img">
						<img :src="gods.goods_image" alt />
					</div>
					<div class="m_title">{{ gods.goods_name }}</div>
					<div class="m_price">
						<i>{{ gods.jinbi }}</i>
						<p class="integral">积分</p>
					</div>
				</div>
			</div>
			<div v-else class="newMode_box">
				<div v-for="(gods, idx) in gosList" :key="idx">
					<homeCard :itemObj='gods' :is_show_price='show_retail_price'></homeCard>
				</div>

			</div>
		</div>

		<div class="hui_m" v-else-if="!isShow && gosList.length == 0" :class="{ 'newMode_null': isNewMode }">
			<div class="search_que">
				<img :src="ossImgPath + 'searchqsy.png'" />
			</div>
		</div>
		<div style="background: #fff;"
			v-if="(isNewMode && ((!isShow && gosList.length == 0 && searchResultNull) || isShow)) && hotList.length > 0">

			<div class="new_banben_box">
				<p class="title_h4"><strong>平台热榜</strong>RANKING</p>
				<div v-for="(item, idx) in hotList" :key='idx' @click="goPathUrl('/shopDetail?id=' + item.stock_id)">
					<NewsProduct :index_s='idx' :itemCont='item' :is_show_retail_price="is_show_retail_price"></NewsProduct>
				</div>
				<span class="go_back" @click="goBackBtn">返回</span>
				<div style="height: 1.76rem;"></div>
			</div>
		</div>
		<div class="no_search_data" v-if="gosList.length > 8 && !isOnload">
			没有更多商品
		</div>


	</div>

</template>

<script>
import icon from '../../components/iconfont.vue'
import {
	getItem,
	setItem,
	removeItem
} from '../../utils/storage.js'
import {
	sendRequest
} from '../../assets/public'
import {
	Dialog
} from 'vant'
import Iconfont from '@/components/iconfont.vue'
import NewsProduct from '@/components/newsProduct'
import homeCard from "@/components/homeCard.vue";
export default {
	components: {
		'qdd-icon': icon,
		Iconfont,
		NewsProduct,
		homeCard
	},
	data() {
		return {
			searchText: '',
			searchHistories: getItem('search-histories') || [], // 搜索历史记录
			suggestions: [],
			gosList: [], //商品列表
			isShow: true, //假的过渡页
			noHistory: true, //展示搜索历史
			page: 1,
			isOnload: true,
			isloading: false,
			orderType: 'asc',
			sortKey: '',
			markColor: '#FD3E3E',
			hotList: [],//平台热卖
			isNewMode: 0,//20240312改版
			searchResultNull: false,
			is_show_retail_price: 0,
			show_retail_price: 0,//搜索结果
		}
	},
	created() {
		// document.body.style.backgroundColor = "#ffffff";
		if (localStorage.getItem('isNewMode')) {
			this.isNewMode = 1
			this.getHotList()
		}
		if (this.$route.query.keyword) {
			this.searchText = this.$route.query.keyword
			this.onSearch(this.searchText)
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handScroll)
	},
	//离开删除绑定事件
	beforeDestroy() {
		window.removeEventListener("scroll", this.handScroll);
	},
	// 监视只有运行的是当前页面才工作
	methods: {
		// 20240312热卖榜
		getHotList() {
			let _this = this;
			sendRequest("goods/list", {
				limit: 10,
				page: 1,
				tag_type: '1',
				goods_type: '0',
			})
				.then((result) => {
					this.is_show_retail_price = result.content.is_show_retail_price;
					let resList = result.content.list
					this.hotList = resList
				})
				.catch((err) => { });
		},
		goPathUrl(e) {
			this.$router.push({
				path: e,
			});
		},
		goBackBtn() {
			this.$router.go(-1);
		},
		init() {
			this.page = 1
			this.gosList = []
			this.isShow = true
			this.noHistory = true
			this.searchText = ''

		},
		// 切换排序
		sortFg(e) {
			if (this.sortKey == e) {
				this.orderType = this.orderType == 'asc' ? 'desc' : 'asc'
			} else {
				this.orderType = 'asc'
			}
			this.sortKey = e
			this.page = 1
			this.gosList = []
			this.getGods()
		},
		async onSearch(q) {
			this.page = 1
			this.gosList = []
			// if (!q.trim().length) {
			//   return
			// }
			this.noHistory = true
			this.searchText = q
			this.isOnload = true
			this.getGods()

			// const { content } = await sendRequest('goods/list', { goods_type: 0, goods_name: this.searchText, page: this.page })
			// if (content.list.length > 0) {
			this.isShow = false
			//   this.gosList = [...this.gosList, ...content.list]
			// } else {
			//   this.isShow = true
			// }
			// 记录历史记录
			if (q.match(/^[ ]*$/)) {
				return
			}
			const searchHistories = this.searchHistories
			const index = searchHistories.findIndex((item) => {
				// 忽略空格、大小写
				return item.trim().toLowerCase() === q.trim().toLowerCase()
			})
			// 如果已存在，则将其移除
			if (index !== -1) {
				searchHistories.splice(index, 1)
			}
			// 将最新搜索记录保存到最前面
			searchHistories.unshift(q)
			if (searchHistories.length > 10) {
				searchHistories.splice(10)
			}
			setItem('search-histories', searchHistories)
		},
		async getGods() {
			this.isloading = false
			const {
				content,
				status,
				msg
			} = await sendRequest('goods/list', {
				goods_type: 0,
				goods_name: this.searchText,
				page: this.page,
				order: this.sortKey,
				order_type: this.orderType,
			})
			this.isloading = true
			if (status != 200) {
				return
			} else {

				this.show_retail_price = content.is_show_retail_price
				if (content.list.length == 0 && this.page == 0) {
					this.isOnload = false
					return
				}
				let shopData = [...this.gosList, ...content.list]
				this.gosList = shopData
				if (this.page == 1 && this.gosList.length == 0) {
					this.searchResultNull = true
				} else {
					this.searchResultNull = false
				}
			}
		},
		handScroll() {
			if (this.page == 1 && this.gosList.length == 0) return false
			console.log('孩子来账号')
			let scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop
			let innerHeight =
				window.innerHeight ||
				document.body.clientHeight ||
				document.documentElement.clientHeight
			if (
				scrollTop + innerHeight + 200 >= document.body.scrollHeight &&
				this.isOnload &&
				this.isloading
			) {
				this.page = this.page + 1
				this.getGods()
			}
		},

		// 删除历史记录
		dele() {
			Dialog.confirm({
				message: '确定删除历史内容吗？',
			}).then(() => {
				removeItem('search-histories')
				this.searchHistories = []
				this.noHistory = false
			})
		},
		// 跳转详情页
		jump(id) {
			this.$router.push({
				name: 'shopDetail',
				query: {
					id: id,
				},
			})
		},
	},
	watch: {
		'$route': {
			handler(to, from) {
				if (from && this.isNewMode && from.path == '/classify') {
					console.log(from, '嘎嘎')
					this.init()
					return
				}
				if (from && from.path == '/') {
					console.log(from, '首页')
					this.init()
				}
				console.log(to, from)
			},
			deep: true,
			immediate: true
		}
	}
}
</script>

<style scoped>
.search_que {
	margin: 4rem auto;
}

.search_que p {
	font-size: 0.6rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(171, 171, 171, 1);
	text-align: center;
}

.search_que img {
	width: 7.56rem;
	height: auto;
}

.search {
	width: 100%;
	/* height: 100%; */
	position: fixed;
	top: 0;
	z-index: 99;
}

.zhan {
	height: 4rem;
}

.two_zhan {
	height: 2.6rem;
}

img {
	width: 100%;
	height: 100%;
}

.noHistory {
	margin-top: 0.6rem;
	font-size: 0.6rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(171, 171, 171, 1);
	text-align: center;
	padding: 1rem 0;
}

.countier {
	background-color: #ffffff;
	min-height: 100vh;
}

.hestort_search {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.2rem 0.6rem;
}

.history_left {
	font-size: 0.52rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(153, 153, 153, 1);
}

.search_history {
	height: 0.6rem;
	padding: 0.2rem 0.6rem;
	background: #f6f5f8;
	text-align: center;
	padding: 0.16rem 0.4rem;
	border: 1px solid rgba(221, 221, 221, 1);
	border-radius: 0.54rem;
	font-size: 0.44rem;
	font-family: PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	background: #fff;
	margin: 0.2rem;
}

.hui_m {
	display: flex;
	flex-wrap: wrap;
	padding: 0.2rem;
	background: #f6f5f8;
}

.hui_m.newMode_null {
	background: #fff;
}

.hui_m.newMode_null .search_que {
	margin: 0 auto;
}

/* 搜索有结果 */
.img {
	width: 4.6rem;
	height: 4.6rem;
	/* background: black; */
	margin: 0 auto;
}

.m_title {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	overflow: hidden;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	font-size: 0.48rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(51, 51, 51, 1);
	margin-top: 0.64rem;
	padding: 0 0.4rem;
}

.m_price {
	display: flex;
	margin-top: 0.2rem;
	/* margin-left: 0.2rem; */
	padding: 0 0.4rem;
}

.m_price i {
	font-size: 0.6rem;
	font-family: PingFang SC;
	font-weight: bold;
	color: rgba(253, 62, 62, 1);
}

.integral {
	padding: 0.1rem 0.2rem;
	height: 0.52rem;
	line-height: 0.52rem;
	text-align: center;
	border: 1px solid rgba(253, 62, 62, 1);
	border-radius: 0.26rem;
	font-size: 0.36rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(253, 62, 62, 1);
	/* margin-top: .7rem; */
	margin-left: 0.2rem;
}

.box {
	width: 6.9rem;
	/* height: 7.84rem; */
	background: #fff;
	border-radius: 0.2rem;
	margin-left: 0.4rem;
	margin-bottom: 0.4rem;
	padding: 0.4rem 0;
}

/* 数据到底部 */
.no_search_data {
	background: #f5f5f5;
	text-align: center;
	font-size: 0.5rem;
	padding-bottom: 0.4rem;
}

.redemption_tab .icon {
	margin-top: 0.4rem;
	margin-left: 0.2rem;
}

.icon {
	line-height: 0.3rem;
	display: block;
}

.iconarrLeft-fill {
	position: relative;
	top: 0.6rem;
}

.iconsanjiao_xia {
	position: relative;
	top: 0.6rem;
}

.filter {
	height: 1.68rem;
	line-height: 1.68rem;
	font-size: 0.52rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(153, 153, 153, 1);
	background: #ffffff;
}

.color {
	color: #fe6157;
}

.new_banben_box {
	/* width: 13.4rem; */
	margin: 0 auto;
	background: linear-gradient(180deg, #FFECEF 0%, #FFF8F8 100%);
	border-radius: 0.48rem;
	border: 1px solid #F5E2E7;
	padding: 0.6rem 0.4rem;
}

.title_h4 {
	color: #FF7E77;
	font-size: 0.52rem;
	margin-bottom: 0.6rem;
	height: 0.64rem;
	line-height: 0.64rem;
}

.title_h4 strong {
	color: #FA2B1F;
	font-weight: bold;
	font-size: 0.64rem;
	display: inline-block;
	margin-right: 0.2rem;
}

.go_back {
	width: 13.72rem;
	height: 1.76rem;
	line-height: 1.76rem;
	background: linear-gradient(90deg, #FFD9DF 0%, #FFEDF0 51%, #FFE0E5 100%);
	border-radius: 0.88rem;
	border: 2px solid #FFDAE0;
	display: block;
	color: #FF463A;
	font-size: 0.64rem;
	text-align: center;
	position: fixed;
	left: 50%;
	bottom: 0.6rem;
	transform: translateX(-50%);
}

.newMode_box {
	width: 100%;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 0 0.2rem;
}

.warp_box_a {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}
</style>